import React from "react";
import HomeLayout from "../layouts/HomeLayout";
import { Container } from "react-bootstrap";
import styled from "styled-components";
import { device } from "../utils/breakpoints";
import { colors } from "../utils/theme";
import { useTranslation } from "react-i18next";
import HireSpaceModal from "../components/Modal/HireSpaceModal";
import MetaTags from "../components/MetaTags";

const Radio = () => {
  const { t } = useTranslation();
  return (
    <HomeLayout>
      <MetaTags
        title={t("meta.radio_title")}
        description={t("meta.radio_description")}
        keywords={t("meta.radio_keywords")}
        path="/radio"
      />
      <Container>
        <Title>{t("radio_page_title")}</Title>
        <Description>{t("radio_page_description")}</Description>
        <div
          style={{
            padding: "2rem 0 0 0",
            position: "relative",
            marginBottom: "3rem",
          }}
        >
          <iframe
            width="100%"
            height="400"
            src="https://www.mixcloud.com/widget/iframe/?hide_cover=1&light=1&feed=%2FOostWestRadio%2F"
            frameBorder="0"
            allow="encrypted-media; fullscreen; autoplay; idle-detection; speaker-selection; web-share;"
          ></iframe>
        </div>
      </Container>
      <HireSpaceModal />
    </HomeLayout>
  );
};

const Description = styled.p`
  font-size: 16px;
  line-height: 24px;
  text-align: center;

  @media ${device.lg} {
    font-size: 20px;
    line-height: 30px;
  }
`;

const Title = styled.h1`
  margin-top: 1rem;
  font-size: 26px;
  font-weight: 700;
  color: ${colors.header};
  margin-bottom: 0.1rem;
  text-align: center;

  @media ${device.lg} {
    font-size: 34px;
  }
`;

export default Radio;
